import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/purchase-invoice-returns/`;
const pathById = `${pathBase}:purchaseInvoiceReturnId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const purchaseInvoiceReturns = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
};
